// src/components/portal/PortalLayout.js
import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import SeasonalEffects from '../SeasonalEffects';

const PortalLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 1024);
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState('');

  // Escucha cambios de tamaño de pantalla
  useEffect(() => {
    const handleResize = () => {
      // Cierra automáticamente el sidebar si la pantalla se vuelve más pequeña que lg
      if (window.innerWidth < 1024) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Actualiza la pestaña actual según la ruta
  useEffect(() => {
    const path = location.pathname.split('/').pop();
    setCurrentTab(path);
  }, [location]);

  return (
    // --- INICIO DE CORRECCIÓN ---
    // Cambiamos h-screen por h-dvh para adaptarnos a las barras del navegador móvil
    <div className="flex h-dvh overflow-hidden bg-gray-100">
    {/* --- FIN DE CORRECCIÓN --- */}
    
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} currentTab={currentTab} />

      {/* Área de contenido */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/* Header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} currentTab={currentTab} />

        <main className="flex-grow">
          {/* Ajustamos padding top para el header fijo */}
          <div className="p-4 sm:p-6 lg:p-8 w-full max-w-7xl mx-auto pt-20 lg:pt-8">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Overlay para móvil (cuando el sidebar está abierto) */}
      {sidebarOpen && (
        <div
           className="fixed inset-0 z-30 bg-black bg-opacity-50 transition-opacity duration-300 ease-in-out lg:hidden"
           onClick={() => setSidebarOpen(false)}
           aria-hidden="true"
         />
      )}

      {/* Efectos visuales */}
      <SeasonalEffects />
    </div>
  );
};

export default PortalLayout;